<template>
    <div class="carousel trend-carousel trends-container">
        <div class="trends-left">
            <carousel ref="carousel"
                      :items="items"
                      :options="options"
                      :show-navigation="false"
                      @slideChange="slideChange">
                <template #slide="{ item }">
                    <a :href="item.link"
                       class="trend-img lazyload"
                       :data-bg="item.image_path">
                        <span class="trend-img-button">В каталог</span>
                    </a>
                </template>
            </carousel>
        </div>
        <div class="trends-right">
            <div class="trend-content">
                <div class="trend-content-description">
                    <a :href="currentItem.link" class="trend-content-description-title">{{ currentItem.title }}</a>
                    <div class="trend-content-description-text" v-html="currentItem.short_description"></div>
                </div>
                <div class="trend-content-examples">
                    <card v-for="(product, p) in currentItem.products.slice(0,productCount)" :key="p" :product="product"
                          :lazyLoad="lazyLoad"></card>
                </div>
            </div>
        </div>
        <navigation v-if="showNavigation" @slide-prev="slidePrev" @slide-next="slideNext"></navigation>
    </div>
</template>

<script>
import Carousel from "./Carousel";
import Navigation from "./Navigation";
import windowWidth from "../../mixins/windowWidth";

export default {
    name: "Trend",
    props: ['items'],
    components: {
        Carousel,
        Navigation,
    },
    mixins: [
        windowWidth
    ],
    data() {
        return {
            index: 0,
            options: {
                loop: true,
                slidesPerView: 1,
            },
            lazyLoad: true,
        }
    },
    computed: {
        showNavigation() {
            return !this.$q.platform.is.mobile && this.items.length > 1;
        },
        currentItem() {
            return this.items[this.index];
        },
        productCount() {
            return this.windowWidth <= 765 ? 2 : 3;
        }
    },
    methods: {
        slidePrev() {
            this.$refs.carousel.slidePrev();

            this.lazyLoad = false;
        },
        slideNext() {
            this.$refs.carousel.slideNext();

            this.lazyLoad = false;
        },
        slideChange(index) {
            this.lazyLoad = false;

            this.index = index;
        }
    }
}
</script>
